import React, { useState } from 'react'
import DriverTable from '../../components/driverTable/DriverTable'

const ManageDriver = () => {

  const [search, setSearch] = useState(null);
  const [status, setStatus] = useState(null);

  return (
    <div className="ta__dashboard">
    <div className="ta__dashboard__breadcrumb">
      <h2 className="f-24">Manage Drivers</h2>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item f-18">
            <a href="/" className="text-gray">
              Home
            </a>
          </li>
          <li
            className="breadcrumb-item f-18 text-black active"
            aria-current="page"
          >
            Drivers
          </li>
        </ol>
      </nav>
    </div>
    <div className="ta__dashboard__body">
      <div className="ta__dashboard_sort">
        <form action="" className="d-flex flex-wrap">
          <div className="col-md-4 col-sm-6 col-12">
            <div className="form_control">
              <label htmlFor="">Status</label>
              <div className="ta__country_dropdown">
                <select 
                 onChange={e => setStatus(e.target.value)}
                >
                  <option value="">All</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Requested">Requested</option>
                  <option value="Pending">Pending</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 col-12">
            <div className="form_control">
              <label htmlFor="">Service</label>
              <div className="ta__country_dropdown">
                <select className="" name="role">
                  <option value="">All</option>
                  <option value="">USA</option>
                  <option value="">India</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 col-12">
            <div className="form_control">
              <label htmlFor="">Driver</label>
              <div className="ta__filterData">
                <input 
                type='text' 
                placeholder='Search driver...'
                className="form-control" 
                name="role"
                onChange={e => setSearch(e.target.value)}
                 />
              </div>
            </div>
          </div>
        </form>
      </div>

      <DriverTable search={search} status={status} />
    </div>
  </div>
  )
}

export default ManageDriver